import { gql } from '@apollo/client'

const PATCH_MEMBER_ANONYMIZATION = gql`
  mutation memberAnonymization($documentNumber: ID!) {
    memberAnonymization(documentNumber: $documentNumber) {
      statusCode
      code
      error
      message
    }
  }
`

export default PATCH_MEMBER_ANONYMIZATION
